import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { ActionForm } from "../../../Shared/Components/ActionForm/ActionForm";
import { ActionFormButtonsContainer } from "../../../Shared/Components/ActionForm/ActionFormButtonsContainer";
import { ActionFormContent } from "../../../Shared/Components/ActionForm/ActionFormContent";
import { ActionFormTextField } from "../../../Shared/Components/ActionForm/ActionFormTextField";

export default function EmployeeForm({ onCancel, onSubmit, employee }) {
    const [loading, setLoading] = useState(false)
    const [values, setValues] = useState({
        name: '',
        other: '',
    })
    useEffect(() => {
        if (!employee) {
            return
        }
        setValues({
            ...employee
        })
    }, [employee])

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleSubmit = (event) => {
        event.preventDefault()
        setLoading(true)
        onSubmit(values)
    }

    const formIsValid = values.name.length >= 3

    const saveButtonTitle = loading ? 'Guardando' : 'Guardar'
    return (
        <ActionForm title={employee ? 'Editar Empleado' : 'Nuevo Empleado'} handleSubmit={handleSubmit}>
            <ActionFormContent>
                <ActionFormTextField
                    label='Nombre y Apellido'
                    value={values.name}
                    isRequired
                    onChange={handleChange('name')}
                />
                <ActionFormTextField
                    label='Otros'
                    value={values.other}
                    isMultiline
                    isRequired={false}
                    onChange={handleChange('other')}
                />
            </ActionFormContent>
            <ActionFormButtonsContainer>
                <Button disabled={!formIsValid || loading} variant="contained" type='submit' color="primary">{saveButtonTitle}</Button>
                <Button className='form-button' onClick={(e) => {
                    e.preventDefault();
                    onCancel()
                }}>Cancelar</Button>
            </ActionFormButtonsContainer>
        </ActionForm>
    )
}
